import { render } from "./recharge-record.vue?vue&type=template&id=5c0fc0b4&scoped=true&ts=true"
import script from "./recharge-record.vue?vue&type=script&lang=ts"
export * from "./recharge-record.vue?vue&type=script&lang=ts"

import "./recharge-record.vue?vue&type=style&index=0&id=5c0fc0b4&lang=stylus&scoped=true"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c0fc0b4"]])

export default __exports__